import React, {PropTypes} from 'react'
import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import {Actions} from 'jumpstate'
import {Form} from 'react-form'
import OwnerBoxForm from './OwnerBoxForm'
import './OwnerBox.css'
import showToastr from '../../../../utils/showToastr'
import ErrorHandler from '../../../../utils/ErrorHandler'
import {convertToGregorian} from '../../../../utils/dateHelper'
import validateOwnerBox from '../../../../utils/validateOwnerBox'

class OwnerBox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: {type: '', context: ''},
      isLoading: false,
      ownerDetails: {
        horse_id: this.props.horse.id,
        name: props.user.currentUser ? props.user.currentUser.full_name : '',
        name_fa: props.user.currentUser ? props.user.currentUser.full_name_fa : '',
        date: ''
      },
      owners: []
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.user.currentUser.full_name !== this.state.name) {
      this.setState({name: nextProps.user.currentUser.full_name, name_fa: nextProps.user.currentUser.full_name_fa})
    }
  }

  render () {
    const {message, isLoading, ownerDetails, owners} = this.state
    const {toggler, isVisible} = this.props
    const hider = () => {
      toggler(false)
    }
    return (
      <Modal show={isVisible} onHide={hider} bsSize="sm" aria-labelledby="contained-modal-title-sm">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-sm">ثبت مالک</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
          مالک شخصی است که اسب در حال حاضر در اختیار اوست.
            <br />
            بدینوسیله تأیید می‌کنید که شما در حال حاضر مالک
            «<b>{this.props.horse.name}</b>»
            می‌باشید، و با <Link to="/page/terms-of-service">قوانین مربوطه</Link> موافق هستید.
          </p>
          {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
          <Form
            ref="ownerForm"
            validate={validateOwnerBox}
            owners={owners}
            user={this.props.user}
            disable={isLoading}
            toggler={toggler}
            birthdate={this.props.horse.born}
            values={ownerDetails}
            placeholder="نوع گزارش"
            onSubmit={(values) => {
              const form = {...values, date: convertToGregorian(values.date)}
              this.setState({isLoading: true})
              Actions.horseSetOwner(form).then((res) => {
                showToastr('success', 'ثبت مالک', res.data.messages[0])
                this.props.toggler(false)
                Actions.horseInfo(this.props.horse.key)
                Actions.userInfo()
                this.setState({isLoading: false})
                typeof (this.props.afterSave) === 'function' && this.props.afterSave()
              }).catch((err) => {
                let eh = new ErrorHandler(err)
                this.setState({message: eh.message, isLoading: false})
                eh.setFormErrors(this.refs.ownerForm)
                eh.showToastrIn('ثبت مالک')
              })
            }} >
            {OwnerBoxForm}
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
}

OwnerBox.propTypes = {
  toggler: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  horse: PropTypes.object.isRequired,
  afterSave: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(OwnerBox)



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseBreederOwner/OwnerBox/OwnerBox.js